import { apiRequestEnvelope } from "./client";
import type {
  AuditLogsResponse,
  LogsQuery,
  PaginationMeta,
} from "@kkp/api-client";

export async function listLogs(
  params: LogsQuery,
): Promise<AuditLogsResponse & PaginationMeta> {
  const search = new URLSearchParams();
  if (params.cursor) search.set("cursor", params.cursor);
  if (params.limit) search.set("limit", String(params.limit));
  if (params.startAt) search.set("startAt", params.startAt);
  if (params.endAt) search.set("endAt", params.endAt);

  const envelope = await apiRequestEnvelope<AuditLogsResponse>({
    path: `/logs${search.toString() ? `?${search.toString()}` : ""}`,
    method: "GET",
  });

  const pagination = envelope.meta?.pagination;

  return {
    items: envelope.data?.items ?? [],
    cursor: pagination?.cursor ?? null,
    nextCursor: pagination?.nextCursor ?? null,
    limit: pagination?.limit ?? params.limit ?? "20",
    total: pagination?.total ?? "0",
  };
}
